import React from 'react';
import { Shield, AlertTriangle, CheckCircle2, Info, FileText, Activity, Layers, AlertCircle, TrendingUp, XCircle, Lock, Eye, Database, UserCheck } from 'lucide-react';
import { AppBadge } from '../components/base/AppBadge';
const MONITORED_SYSTEMS = [{
  id: 's1',
  name: 'Customer Assistant',
  type: 'Chatbot',
  risk: 'Limited',
  status: 'Compliant',
  lastAudit: '12 Ott 2023'
}, {
  id: 's2',
  name: 'Resume Screener',
  type: 'HR Tool',
  risk: 'High',
  status: 'Action Required',
  lastAudit: '05 Ott 2023'
}, {
  id: 's3',
  name: 'Spam Filter',
  type: 'Classifier',
  risk: 'Minimal',
  status: 'Compliant',
  lastAudit: '28 Set 2023'
}, {
  id: 's4',
  name: 'Credit Scoring',
  type: 'Finance',
  risk: 'High',
  status: 'Compliant',
  lastAudit: '10 Ott 2023'
}, {
  id: 's5',
  name: 'Deepfake Generator',
  type: 'Media',
  risk: 'Unacceptable',
  status: 'Blocked',
  lastAudit: '01 Ott 2023'
}];
const REQUIREMENTS = [{
  id: 'req1',
  title: 'Data Governance',
  desc: 'Qualità dei dati di addestramento e mitigazione dei bias.',
  status: 'compliant',
  icon: Database
}, {
  id: 'req2',
  title: 'Transparency',
  desc: 'Tracciabilità e documentazione tecnica aggiornata.',
  status: 'compliant',
  icon: Eye
}, {
  id: 'req3',
  title: 'Human Oversight',
  desc: 'Supervisione umana e possibilità di intervento.',
  status: 'warning',
  icon: UserCheck
}, {
  id: 'req4',
  title: 'Cybersecurity',
  desc: 'Robustezza, accuratezza e sicurezza informatica.',
  status: 'compliant',
  icon: Lock
}];
export function AIActPage() {
  return <div className="min-h-screen bg-[#F4F6F8] p-4 md:p-8" data-id="element-1354">
      {/* Header Section */}
      <div className="mb-8" data-id="element-1355">
        <h1 className="text-[28px] md:text-[32px] font-semibold text-[#2a3a54] tracking-tight" data-id="element-1356">
          AI Act Compliance
        </h1>
      </div>

      {/* Top Stats */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-1357">
        {/* Stat 1 */}
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-1358">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-1359">
            Compliance Score
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1360">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-1361">98%</span>
            <span className="text-[13px] text-emerald-600 font-medium flex items-center gap-1" data-id="element-1362">
              <TrendingUp className="w-3.5 h-3.5" data-id="element-1363" /> +2%
            </span>
          </div>
        </div>

        {/* Stat 2 */}
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-1364">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-1365">
            Sistemi Monitorati
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1366">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-1367">12</span>
            <span className="text-[13px] text-gray-500 font-medium" data-id="element-1368">
              Attivi
            </span>
          </div>
        </div>

        {/* Stat 3 */}
        <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm flex flex-col" data-id="element-1369">
          <h3 className="text-[13px] font-medium text-gray-500 mb-3" data-id="element-1370">
            Sistemi ad Alto Rischio
          </h3>
          <div className="flex items-baseline gap-2 mt-auto" data-id="element-1371">
            <span className="text-[28px] font-bold text-[#1A202C]" data-id="element-1372">2</span>
            <span className="text-[13px] text-amber-600 font-medium flex items-center gap-1" data-id="element-1373">
              <AlertCircle className="w-3.5 h-3.5" data-id="element-1374" /> 1 richiede azione
            </span>
          </div>
        </div>
      </div>

      {/* Table Section */}
      <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden mb-8" data-id="element-1375">
        {/* Modified Header Section */}
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between" data-id="element-1376">
          <h2 className="text-[16px] font-semibold text-[#2a3a54]" data-id="element-1377">
            Sistemi AI Monitorati
          </h2>
          <button className="text-[13px] text-gray-500 font-medium hover:text-[#2a3a54] transition-colors" data-id="element-1378">
            Esporta Report
          </button>
        </div>
        {/* Desktop Table */}
        <div className="hidden md:block overflow-x-auto" data-id="element-1379">
          <table className="w-full text-left border-collapse" data-id="element-1380">
            <thead data-id="element-1381">
              <tr className="bg-gray-50/50 border-b border-gray-100" data-id="element-1382">
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1383">
                  Sistema
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1384">
                  Tipo
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1385">
                  Livello di Rischio
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1386">
                  Status
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider" data-id="element-1387">
                  Ultimo Audit
                </th>
                <th className="px-6 py-3 text-[11px] font-semibold text-gray-500 uppercase tracking-wider text-right" data-id="element-1388">
                  Azioni
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100" data-id="element-1389">
              {MONITORED_SYSTEMS.map(system => <tr key={system.id} className="hover:bg-gray-50/50 transition-colors" data-id="element-1390">
                  <td className="px-6 py-4" data-id="element-1391">
                    <span className="text-[13px] font-medium text-[#2a3a54]" data-id="element-1392">
                      {system.name}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1393">
                    <span className="text-[13px] text-gray-500" data-id="element-1394">
                      {system.type}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1395">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[11px] font-medium border ${system.risk === 'Minimal' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : system.risk === 'Limited' ? 'bg-blue-50 text-blue-700 border-blue-100' : system.risk === 'High' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-1396">
                      {system.risk}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-1397">
                    {system.status === 'Compliant' ? <div className="flex items-center gap-1.5 text-emerald-600" data-id="element-1398">
                        <CheckCircle2 className="w-4 h-4" data-id="element-1399" />
                        <span className="text-[13px] font-medium" data-id="element-1400">
                          Conforme
                        </span>
                      </div> : system.status === 'Action Required' ? <div className="flex items-center gap-1.5 text-amber-600" data-id="element-1401">
                        <AlertTriangle className="w-4 h-4" data-id="element-1402" />
                        <span className="text-[13px] font-medium" data-id="element-1403">
                          Azione Richiesta
                        </span>
                      </div> : <div className="flex items-center gap-1.5 text-red-600" data-id="element-1404">
                        <XCircle className="w-4 h-4" data-id="element-1405" />
                        <span className="text-[13px] font-medium" data-id="element-1406">
                          Bloccato
                        </span>
                      </div>}
                  </td>
                  <td className="px-6 py-4" data-id="element-1407">
                    <span className="text-[13px] text-gray-500" data-id="element-1408">
                      {system.lastAudit}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-1409">
                    <button className="text-[13px] font-medium text-[#00B4D8] hover:text-[#0096b4] transition-colors" data-id="element-1410">
                      Dettagli
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        {/* Mobile Cards */}
        <div className="md:hidden flex flex-col divide-y divide-gray-100" data-id="element-1411">
          {MONITORED_SYSTEMS.map(system => <div key={system.id} className="p-4 flex flex-col gap-3" data-id="element-1412">
              <div className="flex justify-between items-start" data-id="element-1413">
                <div data-id="element-1414">
                  <p className="text-[13px] font-medium text-[#2a3a54]" data-id="element-1415">
                    {system.name}
                  </p>
                  <p className="text-[12px] text-gray-500" data-id="element-1416">{system.type}</p>
                </div>
                <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-[10px] font-medium border ${system.risk === 'Minimal' ? 'bg-emerald-50 text-emerald-700 border-emerald-100' : system.risk === 'Limited' ? 'bg-blue-50 text-blue-700 border-blue-100' : system.risk === 'High' ? 'bg-amber-50 text-amber-700 border-amber-100' : 'bg-red-50 text-red-700 border-red-100'}`} data-id="element-1417">
                  {system.risk}
                </span>
              </div>
              <div className="flex justify-between items-center mt-1" data-id="element-1418">
                <div className="flex items-center gap-1.5" data-id="element-1419">
                  {system.status === 'Compliant' ? <span className="text-[12px] font-medium text-emerald-600 flex items-center gap-1" data-id="element-1420">
                      <CheckCircle2 className="w-3.5 h-3.5" data-id="element-1421" /> Conforme
                    </span> : system.status === 'Action Required' ? <span className="text-[12px] font-medium text-amber-600 flex items-center gap-1" data-id="element-1422">
                      <AlertTriangle className="w-3.5 h-3.5" data-id="element-1423" /> Azione Richiesta
                    </span> : <span className="text-[12px] font-medium text-red-600 flex items-center gap-1" data-id="element-1424">
                      <XCircle className="w-3.5 h-3.5" data-id="element-1425" /> Bloccato
                    </span>}
                </div>
                <button className="text-[12px] font-medium text-[#00B4D8]" data-id="element-1426">
                  Dettagli
                </button>
              </div>
            </div>)}
        </div>
      </div>

      {/* Main Grid */}
    </div>;
}